module.exports = __webpack_public_path__ + "media/images/emblems/Aubonne-coat_of_arms-1c1da911616d1fe8f572a0941e643692.svg";